import { Namespace, useT } from "@racoon/i18n";
import { ChevronLeft } from "lucide-react";

interface EditFieldModalProps {
  isOpen: boolean;
  fieldLabel: string;
  value: string;
  onValueChange: (value: string) => void;
  onCancel: () => void;
  onSave: () => void;
}

export const EditFieldModal = ({
  isOpen,
  fieldLabel,
  value,
  onValueChange,
  onCancel,
  onSave,
}: EditFieldModalProps) => {
  const t = useT();
  if (!isOpen) return null;

  return (
    <div className="absolute inset-0 flex flex-col bg-white z-50">
      {/* Header */}
      <div className="flex-shrink-0 flex items-center justify-between px-4 py-4 ">
        <button
          type="button"
          onClick={onCancel}
          className="flex size-[18px] items-center justify-center rounded-full bg-slate-900 text-white"
        >
          <ChevronLeft className="size-3" strokeWidth={2.5} aria-hidden />
        </button>
        <h2 className="text-lg font-bold flex-1 text-center">{fieldLabel}</h2>
        <div className="w-8" />
      </div>

      {/* Content - Input Field */}
      <div className="flex items-center px-4">
        <input
          type="text"
          value={value}
          onChange={(e) => onValueChange(e.target.value)}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg text-base font-normal focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue"
          placeholder={t(Namespace.Govdash, "placeholder.enterValue")}
          autoFocus
        />
      </div>

      {/* Save Button */}
      <div className="flex-shrink-0 px-4 py-4">
        <button
          type="button"
          onClick={onSave}
          className="w-full px-4 py-3 bg-brand-blue text-white rounded-lg text-base font-semibold hover:bg-blue-700 transition-colors"
        >
          {t(Namespace.Common, "save")}
        </button>
      </div>
    </div>
  );
};
